import styled from '../../utils/styled';
export const SidebarActivatorContainer = styled.div ``;
